import React from 'react';
import { itemSelection } from '../../models/itemSelection.model';
import EntitiesSettings from './index';


interface ElementEntitiesProps {
  setBlockScreen: (p: boolean) => void
}

const ElementEntities: React.FC<ElementEntitiesProps> = ({
  setBlockScreen
}) => {

  const options: itemSelection[] = [
    { 'id': 'type', 'label': 'Tipos de Elementos' },
  ]

  return (
    <React.Fragment>
      <EntitiesSettings
        setBlockScreen={setBlockScreen}
        entity_type='element'
        options={options}
      />
    </React.Fragment>
  )
}

export default ElementEntities;